import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import React, { Component } from 'react';
import { LocalForm } from 'react-redux-form';
import Header from '../Header';
import PropTypes from 'prop-types';
import Footer from '../Footer';
import { Link } from 'react-router-dom';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'user.registration.label.name',
    description: 'Page Header Title',
    defaultMessage: 'User Registration'
  },
  headerSubTitle: {
    id: 'email.verification.sub.title',
    description: 'Page Header Subtitle',
    defaultMessage: 'Email verification'
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

const print = status => {
  if (status.payload) {
    return status.payload.response;
  }
};

class EmailValidation extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    const { intl, error } = this.props;
  }

  componentDidMount() {
    this.props.emailValidation(this.props.match.params[0]);
  }

  render() {
    return (
      <div className="preview page">
        <Header
          title={this.props.intl.formatMessage(messages.headerTitle)}
          subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
          icon="preview"
          locale={this.props.locale}
        />

        <div className="main">
          <div
            className="panel"
            style={{
              width: '60%',
              padding: '40px',
              boxSizing: 'content-box',
              marginTop: '15px',
              display: 'block',
              alignContent: 'center',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >
            <LocalForm onSubmit={this.props.onSubmit}>
              <div className="form">
                <label
                  style={{
                    width: '90%',
                    fontSize: '16px',
                    textTransform: 'none',
                    lineHeight: '150%',
                    color: '#A9A9A9'
                  }}
                >
                  {!this.props.error ? (
                    <div>
                      Thank you for verifying your email address. <br />
                      &nbsp;
                      <br />
                      Your registration request is being processed, and you will
                      be notified by email once approval has been granted.
                    </div>
                  ) : (
                    'Email address verification error'
                  )}
                </label>
                <br />
                &nbsp;
                <br />
                &nbsp;
                <div
                  className="button-container"
                  style={{ textAlign: 'center' }}
                >
                  <Link to="/login">
                    <button className="button" styel={{ padding: 20 }}>
                      <FormattedMessage id="nav.ok" defaultMessage="OK" />
                    </button>
                  </Link>
                </div>
              </div>
            </LocalForm>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default injectIntl(EmailValidation);



// WEBPACK FOOTER //
// ./src/components/views/EmailValidation/index.js